import React from "react";
import { IViewItem } from "../../app/routes/orgChart/types";
import McDropdownNew from "../McDropdown/MCDropdownNew";

const OrgChartViewBar: React.FC<{
  activeView: string;
  arrWithViews: string[];
  setActiveView: (text: string) => void;
}> = ({ activeView, arrWithViews, setActiveView }) => {
  const [viewItems, setViewItems] = React.useState<IViewItem[]>();

  React.useEffect(() => {
    init();
  }, [arrWithViews?.length]);

  const init = () => {
    const _viewItems = arrWithViews.map((item) => {
      return {
        displayValue: item,
      };
    });
    setViewItems(_viewItems);
  };

  return (
    <>
      {viewItems != null && (
        <McDropdownNew
          color="secondary"
          buttonProps={{ style: { width: "150px" } }}
          currentValue={viewItems.find((item) => item.displayValue === activeView)}
          onChange={(_, item: IViewItem) => setActiveView(item?.displayValue)}
          options={viewItems}
          displayKey="displayValue"
          defaultTitle={`${activeView == null ? "Vis detaljer" : `${activeView}`}`}
        />
      )}
    </>
  );
};

export default OrgChartViewBar;
